import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StaffGroupAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-staff-group-audit-list',
  templateUrl: './staff-group-audit-list.component.html',
  styleUrls: ['./staff-group-audit-list.component.scss']
})
export class StaffGroupAuditListComponent implements OnInit {
  @Input() staffGroupId: number;
  @Input() loading: boolean;
  @Input() staffGroupAudits: StaffGroupAudit[];

  @Output() loadStaffGroup = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadStaffGroup.emit(this.staffGroupId);
  }

  onNextPage() {
    this.nextPage.emit(this.staffGroupId);
  }
}
